<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
        .pull-right.m-t-sm
            button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                :disabled="onLoading('save-user') || onLoading('fetch-user')",
                @click="cancel",
            ) Cancel

            button.md-btn.md-raised.m-b-sm.w-xs.green(
                :disabled="onLoading('save-user') || onLoading('fetch-user') || !canUpdate",
                @click="submit",
            )
                v-loading(loader="save-user") Save

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") User Management
                li.breadcrumb-item.active Edit
    .padding
        .box
            .box-header.dker
                h3 Edit User
            .box-divider.m-a-0
            .box-body
                .row
                    .col-md-6
                        .p-a(v-show="!onLoading('fetch-user')")
                            include user-form
</template>

<script>
import userMixin from './user-mixin';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    mixins: [userMixin],

    created() {
        this.fetchUser(this.$route.params.id);
    },

    methods: {
        cancel() {
            this.$router.push('/');
        },

        async submit() {
            if (!(await this.$validator.validate())) {
                return;
            }

            try {
                await this.updateUser();
                this.swal();
                this.$router.push('/');
            } catch (e) {
                if (this.hasLaravelErrors(e)) {
                    this.processLaravelErrors(this.$validator, e.response);
                } else {
                    throw e;
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user/user-edit.vue